import apiClient from '../middleware/apiClient';
import { COTTON_CMS_SUPPORT, CMS_SUPPORT } from '../helpers/apis';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { callApiWithFallback } from '../helpers/apiFallback';
import { kibanaLog } from '../helpers/logger';

export const FETCH_CMS_SUPPORT = 'FETCH_CMS_SUPPORT';
export const FETCH_CMS_SUPPORT_SUCCESS = 'FETCH_CMS_SUPPORT_SUCCESS';
export const FETCH_CMS_SUPPORT_FAILURE = 'FETCH_CMS_SUPPORT_FAILURE';

function dispatchFetchCmsSupport(endpoint = CMS_SUPPORT) {
  return {
    type: FETCH_CMS_SUPPORT,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchFetchCmsSupportSuccess(data) {
  return {
    type: FETCH_CMS_SUPPORT_SUCCESS,
    payload: data,
  };
}

function dispatchFetchCmsSupportFailure(error) {
  return {
    type: FETCH_CMS_SUPPORT_FAILURE,
    payload: error,
  };
}

export const getCmsSupport = () => async (dispatch, getState) => {
  const { cmsSupport = {} } = getState();
  if (cmsSupport.cacheValid || cmsSupport.loading) {
    return null;
  }

  try {
    let response;
    const { isAptV1Enabled, cmsSupportEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      kibanaLog('apt_v1_cms_support_api_called');
      response = await dispatch(dispatchFetchCmsSupport(COTTON_CMS_SUPPORT)).payload;
    } else if (cmsSupportEnabled) {
      response = await callApiWithFallback(
        dispatch,
        () => dispatchFetchCmsSupport(COTTON_CMS_SUPPORT),
        () => dispatchFetchCmsSupport(CMS_SUPPORT),
        'cms_support',
      );
    } else {
      response = await dispatch(dispatchFetchCmsSupport(CMS_SUPPORT)).payload;
    }

    return dispatch(dispatchFetchCmsSupportSuccess(response));
  } catch (error) {
    return dispatch(dispatchFetchCmsSupportFailure(error));
  }
};
